var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button } from "semantic-ui-react";
var ChangeDefaultVariantModal = /** @class */ (function (_super) {
    __extends(ChangeDefaultVariantModal, _super);
    function ChangeDefaultVariantModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/defaultVariant/id/" + encodeURIComponent(_this.props.newDefaultVariant.id.toString()), {});
        };
        return _this;
    }
    ChangeDefaultVariantModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Are you sure you want to change the default for ",
                this.props.currentDefaultVariant.probeSetSize,
                " from ",
                this.props.currentDefaultVariant.name),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'star', label: 'Set as default', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return ChangeDefaultVariantModal;
}(React.PureComponent));
export default ChangeDefaultVariantModal;
//# sourceMappingURL=ChangeDefaultVariantModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChangeDefaultVariantModal.js
// module id = 1460
// module chunks = 0